import React from "react";
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";
import { Box, Button, Chip, List, ListItem, ListItemIcon, ListItemText, Paper, Stack, Typography } from "@mui/material";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import PolicyOutlinedIcon from "@mui/icons-material/PolicyOutlined";

import { Say } from "../../../../../arc/locale/consts.js";
import { Locale } from "../../../../assets/Locale.js";
import { formatProfileDate, getAvConsent, hasProfileValue } from "../profilePrivateTools";

import "./ConsentsPanel.scss";
import { usePop } from "@randajan/jet-react/dom/modal";

const signRows = Object.freeze([
    {
        id: "privacy",
        field: "signedPrivacyAt",
        icon: GppGoodOutlinedIcon
    },
    {
        id: "terms",
        field: "signedTermsAt",
        icon: DescriptionOutlinedIcon
    },
    {
        id: "booking",
        field: "signedBookingAt",
        icon: DescriptionOutlinedIcon
    },
]);

export const ConsentsPanel = (props) => {
    const { profile = {} } = props;
    const say = Locale.use();
    const avConsent = getAvConsent(profile);

    const pop = usePop({ lock: false });

    return (
        <Block tagName="section" className="ConsentsPanel wall -form">
            <div className="header">
                <Caption className="BlimpMuiPanel-title">{say("profileConsentsCaption")}</Caption>
            </div>
            <ul className="iconized -checklist">
                {signRows.map(row => {
                    const Icon = row.icon;
                    const signed = hasProfileValue(profile[row.field]);

                    return (
                        <li key={row.field}>
                            <Icon fontSize="small" />
                            <Block caption={say(Say.id("profile", "consents", row.id))}>
                                <p className="font -fade">{formatProfileDate(profile[row.field])}</p>
                                
                            </Block>
                            {!signed ? null : <Chip
                                className="BlimpMuiPanel-status isPositive"
                                icon={<CheckCircleOutlineOutlinedIcon />}
                                label={say("profileConsentsAccepted")}
                                variant="outlined"
                            />}

                        </li>
                    );
                })}
                <li>
                    <PolicyOutlinedIcon fontSize="small" />
                    <Block caption={say("profileConsentsAvLicence")}>
                        <p className="font -fade">{avConsent.dates}</p>
                    </Block>
                    <Chip
                        className="BlimpMuiPanel-status isPositive"
                        icon={<CheckCircleOutlineOutlinedIcon />}
                        label={say("profileConsentsAvProgress").replace("$", avConsent.count)}
                        variant="outlined"
                    />
                </li>
            </ul>
            <section className="controls">
                {/* <Button
                    className="BlimpMuiPanel-action"
                    startIcon={<ArticleOutlinedIcon />}
                    variant="outlined"
                    onClick={_ => pop.up()}
                >
                    {say("profileConsentsShow")}
                </Button> */}
            </section>
        </Block>
    );
};
